import React from "react";
import "./FoodItem.css";
import { Link } from "react-router-dom";

const FoodItem = ({ food, user }) => {
  return (
    <div className="food">
      {!food.quantity && (
        <div className={!food.quantity ? "food__status" : null}>
          <h3 className="status__text">Sold Out</h3>
        </div>
      )}
      <div className="food__img--container">
        <img
          className="food__img"
          src={process.env.REACT_APP_IMAGES_URL + food.foodImage}
          alt="food"
        />
      </div>
      <div className="food__text">
        <h3 className="food__title">{food.title}</h3>
      </div>

      <div className="food__info">
        <div className="food__buttons">
          <Link
            to={`/orders/${food._id}`}
            className="btn m-r-s link food__order"
          >
            Order
          </Link>
          <Link to={`/foods/${food._id}`} className="btn link food__order">
            Details
          </Link>
        </div>
        <p className="food__price">{food.price} $</p>
      </div>
    </div>
  );
};

export default FoodItem;
